/**
 * Generated from ch7_p05.fla
 */
export function ch7_p05(this: Ich7_p05) {
	const bg = this.bg;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_holly.call(this.holly);
	holly.x = 529.5;
	holly.y = 637.5;
	holly.width = 246.00;
	holly.height = 509.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const house = this.house;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bushhouse.call(this.house);
	house.x = 1075.25;
	house.y = 384;
	house.width = 1177.50;
	house.height = 768.00;
	house.alpha = 1.00;
	if (house.onLayout) house.onLayout();
	const frameRight = this.frameRight;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRrlines.call(this.linesRight);
	linesRight.x = 1650;
	linesRight.y = 384;
	linesRight.width = 8.00;
	linesRight.height = 768.00;
	linesRight.alpha = 0.50;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 343.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLayer944.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 435.5;
	linesLeft.width = 170.50;
	linesLeft.height = 464.00;
	linesLeft.alpha = 0.50;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bg(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p05_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_holly(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p05_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bushhouse(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bushhouse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p05_bushhouse", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRRframe(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRrlines(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRrlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLframe(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLayer944(this: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLayer944) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer944", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich7_p05Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p05Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p05Sprite extends Ich7_p05Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p05Text extends Ich7_p05Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p05Polygon extends Array<number> {
}
interface Ich7_p05 {
	readonly bg: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bg;
	readonly holly: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_holly;
	readonly house: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bushhouse;
	readonly frameRight: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRRframe;
	readonly linesRight: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRrlines;
	readonly frameLeft: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLframe;
	readonly linesLeft: Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLayer944;
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bg extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_holly extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_bushhouse extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRRframe extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeRrlines extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLframe extends Ich7_p05Sprite {
}
interface Ich7_p05_hh_ch7_72dpi_p05psdAssetchp7_p05_wcframeLLayer944 extends Ich7_p05Sprite {
}
